// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"Disclaimer_MainContainer__3iRJC","Text":"Disclaimer_Text__1N9Ys"};